// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gallery.css - Scoped and Standalone Styles for Gallery Component */

/* --- Keyframe Animation --- */
@keyframes GalleryModalFadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}


/* ==================================================== */
/* 1. Modal Container and Structure (Scoped) */
/* ==================================================== */

.GalleryModal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.GalleryModal-content {
    background: #f7f9fc; /* Light background for contrast */
    padding: 30px;
    border-radius: 12px;
    position: relative;
    width: 60%; 
    max-width: 900px; /* Slightly wider gallery */
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
    max-height: 80%; 
    overflow-y: auto;
    animation: GalleryModalFadeIn 0.3s forwards;
    opacity: 0;
}

.GalleryModal-title {
    color: #2c3e50;
    border-bottom: 2px solid #ecf0f1;
    padding-bottom: 10px;
    margin-bottom: 20px;
    font-size:25px;

}

/* --- Close Button (Scoped) --- */
.GalleryModal-close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #95a5a6;
    transition: color 0.2s;
    z-index: 11; 
}
.GalleryModal-close-button:hover {
    color: #e74c3c;
}


/* ==================================================== */
/* 2. UPLOAD SECTION STYLING (Scoped) */
/* ==================================================== */

.GalleryModal-upload-form {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px dashed #bdc3c7;
    border-radius: 8px;
    background-color: #ffffff;
}

.GalleryModal-file-input-group {
    display: flex;
    gap: 10px;
    align-items: center;
}

.GalleryModal-file-label {
    flex-grow: 1;
    padding: 10px 15px;
    border: 1px solid #3498db;
    border-radius: 4px;
    background-color: #3498db;
    color: white;
    cursor: pointer;
    font-weight: 600;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.GalleryModal-upload-button {
    padding: 10px 20px;
    background-color: #2ecc71;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.2s;
    width: 150px;
}

.GalleryModal-upload-button:hover:not(:disabled) {
    background-color: #27ae60;
}

.GalleryModal-upload-button:disabled {
    background-color: #95a5a6;
    cursor: not-allowed;
}

.GalleryModal-upload-note {
    display: block;
    margin-top: 10px;
    color: #7f8c8d;
    text-align: right;
    font-size: 0.85em;
}


/* ==================================================== */
/* 3. IMAGE GRID & CARD STYLING (Scoped) */
/* ==================================================== */

.GalleryModal-image-grid-container {
    display: grid; 
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); 
    gap: 20px;
    padding: 10px 0;
}

/* Wrapper for card + name */
.GalleryModal-image-item-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px; /* Space between card and name */
}

.GalleryModal-image-card {
    position: relative; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; 
    
    background-color: #ffffff;
    border: 3px solid transparent; 
    border-radius: 12px; 
    padding: 0; 
    overflow: hidden; 
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08); 
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;
    width: 100%; 
    aspect-ratio: 1 / 1; 
}

.GalleryModal-image-card:hover {
    box-shadow: 0 8px 20px rgba(52, 152, 219, 0.25);
    transform: translateY(-4px); 
    border-color: #3498db; 
}

.GalleryModal-gallery-image {
    width: 100%; 
    height: 100%; 
    object-fit: cover; 
    transition: transform 0.3s ease;
}

.GalleryModal-image-card:hover .GalleryModal-gallery-image {
    transform: scale(1.05); 
}

/* Delete Icon */
.GalleryModal-delete-icon-button {
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: rgba(231, 76, 60, 0.85); 
    color: white;
    border: none;
    border-radius: 50%; 
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
    cursor: pointer;
    opacity: 0; 
    transform: scale(0.8); 
    transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s;
    z-index: 10; 
    padding: 0;
}

.GalleryModal-image-card:hover .GalleryModal-delete-icon-button {
    opacity: 1; 
    transform: scale(1);
}

.GalleryModal-delete-icon-button:hover {
    background-color: #c0392b; 
    transform: scale(1.1); 
}

/* Image Name outside the card */
.GalleryModal-image-name-below {
    font-size: 10px; 
    color: #34495e; 
    font-weight: 500; 
    width: 100%; 
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; 
}


/* --- Error Message Styling --- */
.GalleryModal-error-message, .GalleryModal-empty-gallery-message {
    color: #e74c3c;
    text-align: center;
    padding: 20px;
    border: 1px solid #e74c3c;
    background-color: #fcecec;
    border-radius: 8px;
    margin-top: 20px;
}

.GalleryModal-empty-gallery-message {
    color: #7f8c8d;
    border-color: #bdc3c7;
    background-color: #f0f3f5;
}


/* --- DESKTOP/Larger Screen Adjustments --- */
@media (min-width: 600px) {
    .GalleryModal-file-label {
        text-align: left;
        margin-bottom: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Gallery.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE,+BAA+B;AAC/B;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA,yDAAyD;AACzD,8CAA8C;AAC9C,yDAAyD;;AAEzD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB,EAAE,kCAAkC;IACvD,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB,EAAE,2BAA2B;IAC7C,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;;AAElB;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,cAAc;AAClB;;;AAGA,yDAAyD;AACzD,uCAAuC;AACvC,yDAAyD;;AAEzD;IACI,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA,yDAAyD;AACzD,0CAA0C;AAC1C,yDAAyD;;AAEzD;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ,EAAE,gCAAgC;AAC9C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,0CAA0C;IAC1C,gFAAgF;IAChF,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,yCAAyC;IACzC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,yEAAyE;IACzE,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA,kCAAkC;AAClC;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;;AAGA,8CAA8C;AAC9C;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":["/* Gallery.css - Scoped and Standalone Styles for Gallery Component */\n\n/* --- Keyframe Animation --- */\n@keyframes GalleryModalFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n/* ==================================================== */\n/* 1. Modal Container and Structure (Scoped) */\n/* ==================================================== */\n\n.GalleryModal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.GalleryModal-content {\n    background: #f7f9fc; /* Light background for contrast */\n    padding: 30px;\n    border-radius: 12px;\n    position: relative;\n    width: 60%; \n    max-width: 900px; /* Slightly wider gallery */\n    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);\n    max-height: 80%; \n    overflow-y: auto;\n    animation: GalleryModalFadeIn 0.3s forwards;\n    opacity: 0;\n}\n\n.GalleryModal-title {\n    color: #2c3e50;\n    border-bottom: 2px solid #ecf0f1;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n    font-size:25px;\n\n}\n\n/* --- Close Button (Scoped) --- */\n.GalleryModal-close-button {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #95a5a6;\n    transition: color 0.2s;\n    z-index: 11; \n}\n.GalleryModal-close-button:hover {\n    color: #e74c3c;\n}\n\n\n/* ==================================================== */\n/* 2. UPLOAD SECTION STYLING (Scoped) */\n/* ==================================================== */\n\n.GalleryModal-upload-form {\n    margin-bottom: 30px;\n    padding: 20px;\n    border: 1px dashed #bdc3c7;\n    border-radius: 8px;\n    background-color: #ffffff;\n}\n\n.GalleryModal-file-input-group {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.GalleryModal-file-label {\n    flex-grow: 1;\n    padding: 10px 15px;\n    border: 1px solid #3498db;\n    border-radius: 4px;\n    background-color: #3498db;\n    color: white;\n    cursor: pointer;\n    font-weight: 600;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.GalleryModal-upload-button {\n    padding: 10px 20px;\n    background-color: #2ecc71;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background-color 0.2s;\n    width: 150px;\n}\n\n.GalleryModal-upload-button:hover:not(:disabled) {\n    background-color: #27ae60;\n}\n\n.GalleryModal-upload-button:disabled {\n    background-color: #95a5a6;\n    cursor: not-allowed;\n}\n\n.GalleryModal-upload-note {\n    display: block;\n    margin-top: 10px;\n    color: #7f8c8d;\n    text-align: right;\n    font-size: 0.85em;\n}\n\n\n/* ==================================================== */\n/* 3. IMAGE GRID & CARD STYLING (Scoped) */\n/* ==================================================== */\n\n.GalleryModal-image-grid-container {\n    display: grid; \n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); \n    gap: 20px;\n    padding: 10px 0;\n}\n\n/* Wrapper for card + name */\n.GalleryModal-image-item-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px; /* Space between card and name */\n}\n\n.GalleryModal-image-card {\n    position: relative; \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; \n    \n    background-color: #ffffff;\n    border: 3px solid transparent; \n    border-radius: 12px; \n    padding: 0; \n    overflow: hidden; \n    cursor: pointer;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08); \n    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;\n    width: 100%; \n    aspect-ratio: 1 / 1; \n}\n\n.GalleryModal-image-card:hover {\n    box-shadow: 0 8px 20px rgba(52, 152, 219, 0.25);\n    transform: translateY(-4px); \n    border-color: #3498db; \n}\n\n.GalleryModal-gallery-image {\n    width: 100%; \n    height: 100%; \n    object-fit: cover; \n    transition: transform 0.3s ease;\n}\n\n.GalleryModal-image-card:hover .GalleryModal-gallery-image {\n    transform: scale(1.05); \n}\n\n/* Delete Icon */\n.GalleryModal-delete-icon-button {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background-color: rgba(231, 76, 60, 0.85); \n    color: white;\n    border: none;\n    border-radius: 50%; \n    width: 28px;\n    height: 28px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.2em;\n    cursor: pointer;\n    opacity: 0; \n    transform: scale(0.8); \n    transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s;\n    z-index: 10; \n    padding: 0;\n}\n\n.GalleryModal-image-card:hover .GalleryModal-delete-icon-button {\n    opacity: 1; \n    transform: scale(1);\n}\n\n.GalleryModal-delete-icon-button:hover {\n    background-color: #c0392b; \n    transform: scale(1.1); \n}\n\n/* Image Name outside the card */\n.GalleryModal-image-name-below {\n    font-size: 10px; \n    color: #34495e; \n    font-weight: 500; \n    width: 100%; \n    text-align: center;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; \n}\n\n\n/* --- Error Message Styling --- */\n.GalleryModal-error-message, .GalleryModal-empty-gallery-message {\n    color: #e74c3c;\n    text-align: center;\n    padding: 20px;\n    border: 1px solid #e74c3c;\n    background-color: #fcecec;\n    border-radius: 8px;\n    margin-top: 20px;\n}\n\n.GalleryModal-empty-gallery-message {\n    color: #7f8c8d;\n    border-color: #bdc3c7;\n    background-color: #f0f3f5;\n}\n\n\n/* --- DESKTOP/Larger Screen Adjustments --- */\n@media (min-width: 600px) {\n    .GalleryModal-file-label {\n        text-align: left;\n        margin-bottom: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
